// extracted by mini-css-extract-plugin
export default {"modal":"Statistic_modal__KuB48","close_button":"Statistic_close_button__gD4qW"};